"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFixedPrice = function IconFixedPrice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7 5h2v36h32v2H7zm29.275 15.554A3 3 0 0 1 38 20a2.994 2.994 0 1 1-2.816 4h-6.368a2.982 2.982 0 0 1-5.632 0h-6.368a3 3 0 1 1 0-2h6.368a2.981 2.981 0 0 1 5.632 0h6.368a3 3 0 0 1 1.091-1.446m-22.83 3.277a1 1 0 1 0 1.11-1.663 1 1 0 0 0-1.11 1.663m12 0a1 1 0 1 0 1.11-1.663 1 1 0 0 0-1.11 1.663m12 0a1 1 0 1 0 1.11-1.663 1 1 0 0 0-1.11 1.663m-15.299 1.315L15 32.293l-3.146-3.147-.708.708L15 33.707l7.854-7.853zm6-6L36 11.293l5.854 5.853-.708.708L36 12.707l-7.146 7.147z",
    clipRule: "evenodd"
  })));
};

export { IconFixedPrice, IconFixedPrice as default };
